module.exports = __webpack_public_path__ + "img/rs_fwt18-logo.434a78a.png";